import { render, staticRenderFns } from "./pricing-insights.vue?vue&type=template&id=3aa56096&scoped=true"
import script from "./pricing-insights.vue?vue&type=script&lang=js"
export * from "./pricing-insights.vue?vue&type=script&lang=js"
import style0 from "./pricing-insights.vue?vue&type=style&index=0&id=3aa56096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa56096",
  null
  
)

export default component.exports